/**
 * Cart extras (snippets/lytes-free-shipping, snippets/lytes-cart-line-subscribe), in the drawer
 * and on the cart page: "+" adds a free-shipping suggestion, and a one-time line can be switched
 * to an Auto Delivery plan. Afterwards Horizon's cart re-renders via window.lytesCartRefresh.
 */
const post = (url, body) =>
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  }).then((res) => {
    if (!res.ok) throw new Error(`${url} ${res.status}`);
    return res.json();
  });

const refresh = (lines) => {
  if (window.lytesCartRefresh) return window.lytesCartRefresh(lines);
  window.location.reload();
};

document.addEventListener('click', (event) => {
  const target = /** @type {HTMLElement} */ (event.target);

  const add = target.closest('[data-lytes-cart-add]');
  if (add instanceof HTMLButtonElement) {
    if (add.disabled) return;
    add.disabled = true;
    const id = add.dataset.lytesCartAdd;
    post('/cart/add.js', { items: [{ id, quantity: 1 }] })
      .then(() => refresh([{ id, quantity: 1 }]))
      .catch(() => (add.disabled = false));
    return;
  }

  const box = target.closest('[data-lytes-line-sub]');
  if (!box) return;

  if (target.closest('[data-lytes-line-sub-open]')) box.setAttribute('data-step', '2');
  if (target.closest('[data-lytes-line-sub-back]')) box.setAttribute('data-step', '1');

  const swap = target.closest('[data-lytes-line-sub-switch]');
  if (swap instanceof HTMLButtonElement && !swap.disabled) {
    const plan = box.querySelector('input[type="radio"]:checked');
    if (!(plan instanceof HTMLInputElement)) return;
    swap.disabled = true;
    post('/cart/change.js', {
      id: swap.dataset.lytesLineSubSwitch,
      quantity: Number(swap.dataset.quantity) || 1,
      selling_plan: Number(plan.value),
    })
      .then(() => refresh([]))
      .catch(() => (swap.disabled = false));
  }
});
